import { type MCPServerInfo } from '../../types';

const ZoomInfoServer: MCPServerInfo = {
  serverId: 'ZOOMINFO',
  name: 'ZoomInfo',
  slug: 'zoominfo',
  description:
    'Official ZoomInfo remote MCP server. Search 100M+ companies and 300M+ contacts, enrich profiles, and access CRM and conversation history.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.zoominfo.com/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default ZoomInfoServer;
